import React from 'react';
import PropTypes from 'prop-types';
import { rupiah } from 'utils/formatter';

class RefundSubTotal extends React.Component {
  render() {
    const { subtotal } = this.props;
    return (
      <div>
        <div className="pull-left">Subtotal</div>
        <div className="pull-right">{this._formatSubtotal(subtotal)}</div>
        <div className="clearfix" />
      </div>
    );
  }

  _formatSubtotal = subtotal => {
    if (subtotal > 0) {
      return `(${rupiah(subtotal)})`;
    }
    return `(${rupiah(-1 * subtotal)})`;
  };
}

RefundSubTotal.propTypes = {
  subtotal: PropTypes.number,
};

export default RefundSubTotal;
